<template>
    <div class="form-type-2 mode">
        <CustomRadio
            :modelValue="mode"
            :inputKey="name"
            :showLabel="false"
            :showDescription="false"
            :options="options"
            ref="quickSearch"
            cssClass="custom-radio-type-6"
            @update:modelValue="onChanged"
            @current-reselected="onReselected"
        />
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import { useAccountStore } from '@/stores/account';
    import { usePopupStore } from '@/stores/utils/popup';
    import CustomRadio from '@/components/elements/inputs/CustomRadio';

    export default {
        name: "CompaniesMode",
        components: {
            CustomRadio
        },
        data() {
            return {
                name: 'companies_mode',
                modes: [
                    {
                        key: 'all',
                        icon: 'company'
                    },
                    {
                        key: 'new',
                        icon: 'new'
                    },
                    {
                        key: 'prospects',
                        icon: 'target'
                    }
                ]
            };
        },
        computed: {
            ...mapState(useCompaniesStore, ['mode', 'audienceId', 'hasDefaultOptions', 'currentCompanyIndex']),
            ...mapState(useAccountStore, ['paywall', 'isAdmin']),
            options() {
                return this.modes.map(mode => ({
                    value: mode.key,
                    text: 'fields.companies_mode.modes.' + mode.key,
                    image: mode.icon,
                    ...(mode.key === 'prospects' && (!this.audienceId || !this.hasDefaultOptions) ? {
                        disabled: true,
                        fn: this.prospectsDisabledPopup
                    } : {}),
                    ...(mode.key === 'new' && this.paywall ? {
                        disabled: true,
                        fn: this.isAdmin ? this.suspectsDisabledPopupAdmin : this.suspectsDisabledPopupUser
                    } : {}),
                }))
            },
        },
        methods: {
            onChanged(newValue) {
                useCompaniesStore().routeToMode(newValue);
            },
            onReselected(value) {
                if(this.currentCompanyIndex !== null && (value === 'prospects' || value === 'all')) {
                    useCompaniesStore().closeCompany();
                }
            },
            prospectsDisabledPopup() {
                usePopupStore().showPopup('notice', {
                    title: this.mode === 'new' || (this.mode === 'all' && this.currentCompanyIndex !== null) ? 'popups.prospects_disabled_2.title' : 'popups.prospects_disabled_1.title',
                    description: this.mode === 'new' || (this.mode === 'all' && this.currentCompanyIndex !== null) ? 'popups.prospects_disabled_2.description' : 'popups.prospects_disabled_1.description',
                    closeButtonText: this.mode === 'new' || (this.mode === 'all' && this.currentCompanyIndex !== null) ? 'popups.prospects_disabled_2.button_confirm' : 'popups.prospects_disabled_1.button_confirm'
                });
            },
            suspectsDisabledPopupAdmin() {
                usePopupStore().showPopup('confirm', {
                    title: 'popups.suspects_disabled_1.title',
                    description: 'popups.suspects_disabled_1.description',
                    btnConfirm: 'popups.suspects_disabled_1.button_confirm',
                    confirmFunction: () => {
                        this.$router.push({
                            name: 'subscriptions'
                        });
                    },
                });
            },
            suspectsDisabledPopupUser() {
                usePopupStore().showPopup('notice', {
                    title: 'popups.suspects_disabled_2.title',
                    description: 'popups.suspects_disabled_2.description',
                    closeButtonText: 'popups.suspects_disabled_2.button_confirm'
                });
            },
        }
    }
</script>